export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/chevronRight.f36c85e7.svg","height":14,"width":9,"blurWidth":0,"blurHeight":0};